import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import "./questionnaire.scss";
import "src/components/modules/ClinicianAvailabilityTherapistsList/therapists-list.scss";

const LogoContainer = () => {
    const poweredByI2ILogo = useSelector(
        (state) => state?.configuration?.poweredByI2ILogo
    );

    useEffect(() => {
        const pageContainer = document.querySelector(
            ".session-questionnaire-container"
        );
        const logo = document.querySelector(".powered-by-self");

        function handleLogoPosition() {
            const appBottomFixedButton = document.querySelector(".app-bottom-fixed-button");

            if (pageContainer && !"clientOnboardingBySchedulerWelcomePage") {
                if (
                    pageContainer?.scrollHeight >
                    document?.documentElement?.clientHeight - 100
                ) {
                    // Content is taller or equal to the viewport, so position the logo relative to the content.
                    logo?.classList.remove("fixed-logo");
                } else {
                    // Content is shorter than the viewport, so position the logo as a fixed footer.
                    logo?.classList.add("fixed-logo");
                }
            }

            if (logo?.classList.contains("fixed-logo")) {
                if (appBottomFixedButton) {
                    logo.style.marginBottom = "100px";
                } else {
                    logo.style.marginBottom = "";
                }
            }
        }

        // Initial positioning
        handleLogoPosition();

        // Listen for window resize and updates
        window.addEventListener("resize", handleLogoPosition);
        pageContainer?.addEventListener("scroll", handleLogoPosition);

        // MutationObserver to detect changes in the DOM
        const observer = new MutationObserver(handleLogoPosition);

        observer.observe(document.body, { childList: true, subtree: true });

        return () => {
            window.removeEventListener("resize", handleLogoPosition);
            pageContainer?.removeEventListener("scroll", handleLogoPosition);
            observer.disconnect();
        };
    }, []);

    return (
        <>
            {poweredByI2ILogo && (
                <div className="text-center powered-by-self">
                    <div className="poweredby_logo">
                        <img
                            src={`${decodeURIComponent(poweredByI2ILogo)}`}
                            alt="logo"
                            className="d-inline-block"
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default LogoContainer;

